
import { Component, computed, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SiCardModule } from '@siemens/element-ng/card';

@Component({
  selector: 'app-infos',
  imports: [SiCardModule, TranslateModule],
  templateUrl: './infos.component.html',
  styleUrl: './infos.component.scss'
})
export class InfosComponent {
  readonly results = input.required<any>();

  readonly infoResults = computed(() => {
    return this.results().simulation_results.info;
  });

  getKeys(obj: any): string[] {
    return Object.keys(obj);
  }
}
